import { useContext, useState } from 'react';
import { UserContext } from '../Context/UserContext'
import axios from 'axios'
import { useHistory } from 'react-router-dom';
import { UserOutlined, KeyOutlined } from '@ant-design/icons'
import { Card, Button, Form, Input, Alert, Row, Col} from 'antd';
import { ThemeContext } from '../Context/ThemeContext';


const Login = () => {
    const [, setUser] = useContext(UserContext)
    const [,,,setDashboard] = useContext(UserContext)
    const [theme] = useContext(ThemeContext)
    const [error, setError] = useState()
    const history = useHistory()

    const changeNameClass =  theme === 'dark' ? 'dark-nav' : theme === 'light' ? 'light-nav': ''

    const onFinish = (values) => {
        axios.post("https://backend-sportyan.vercel.app/api/login", {...values})
            .then((res) => {
                console.log(res)
                let dataUser = res.data.user
                let token = res.data.token
                setUser({...dataUser, token})
                localStorage.setItem("user", JSON.stringify({...dataUser, token}))
                setDashboard(true)
                history.push("/dashboard")
            }).catch((err) => {
                setError(err.response.data.error)
                alert("Your password or email is wrong!")
            })
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    return (
        <>
        <div className='card-login'>
            <div className='card-login-box'>

            <Card className={changeNameClass} style={{marginTop: "3vh", boxShadow: "3px 3px 1px 1px #009FB7", borderRadius: "20px", height: "375px", width:"500px"}}>
                <h1 style={{fontSize: "30px", textAlign: "center", marginTop: "5vh"}}>LOGIN</h1>
                <Row justify="center" style={{marginBottom: "30px"}}>
                    <Col span={9}>
                        {
                            error && <Alert message="Your password or email is wrong!" type="error" closable showIcon/>
                        }
                    </Col>
                </Row>
                
                <Form
                className={changeNameClass}
                name="login"
                labelCol={{
                    span: 6,
                }}
                wrapperCol={{
                    span: 15,
                }}
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                >
                
                <Form.Item
                    label={<label className={changeNameClass}>Email</label>}
                    name="email"
                    rules={[
                        {
                            required: true,
                            type: 'email',
                            message: 'Please input your email!'
                        }
                    ]}
                >
                    <Input prefix={<UserOutlined />}/>
                </Form.Item>

                <Form.Item
                    label={<label className={changeNameClass}>Password</label>}
                    name="password"
                    rules={[
                    {
                        required: true,
                        min: 6,
                        message: 'Please input your password more than 6 character!',
                    },
                    
                    ]}
                >
                    <Input.Password prefix={<KeyOutlined />}/>
                </Form.Item>

                <Form.Item
                    wrapperCol={{
                    offset: 6,
                    span: 15,
                    }}
                >
                    <Button type="primary" htmlType="submit" style={{background: "#009FB7"}}>
                    Submit
                    </Button>
                    <p style={{marginTop: "10px"}}> Don't have account? <a href='/register'>Register Now!</a></p>
                    {/* Or <a href='/register' onClick={HandleRegister} style={{marginLeft: "10px"}}>register now!</a> */}
                </Form.Item>
            </Form>
            </Card>
            </div>

        </div>
        </>
    )

}

export default Login